/**
 * GeneratingCard — 「手寫緊」（設計 v2 §4 **C05**；UI v2 **步 13**）
 *
 *   · 階段文字（聽／寫詞／作曲／混音）＋ 預計分鐘；⚠️ **無倒數**（設計硬規則）＋ 可繼續傾
 *   · ⚠️ **R-01**：後端未回 `stage` → **前端佔位**（按經過時間粗略推估，唔准當真）
 */
import { useTranslation } from 'react-i18next';

/** 4 個階段（i18n key；設計 §10） */
const STAGES = ['gen_stage_listen', 'gen_stage_lyrics', 'gen_stage_compose', 'gen_stage_mix'] as const;

/** 「手寫緊」墨線（純裝飾；設計 `InkLine`） */
function InkLine() {
  return (
    <svg viewBox="0 0 320 28" preserveAspectRatio="none" aria-hidden="true">
      <path
        d="M4 18 C 18 8, 26 24, 40 14 S 62 10, 74 18 S 96 22, 108 12 S 130 8, 142 19 S 168 24, 182 13 S 206 9, 220 18 S 246 22, 258 12 S 286 10, 300 17"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export interface GeneratingCardProps {
  /** 而家喺第幾階段（0–3；R-01 前端佔位） */
  stage: number;
}

export default function GeneratingCard({ stage }: GeneratingCardProps) {
  const { t } = useTranslation();
  const now = Math.max(0, Math.min(3, stage));

  return (
    <div className="gencard card" data-testid="generating-card" role="status" aria-label={t('gen_stage_aria')}>
      <div className="gencard__head">
        <span className="gencard__dot" aria-hidden="true" />
        {t('song_render_pending')}
      </div>
      <div className="gencard__ink" aria-hidden="true">
        <InkLine />
      </div>
      <ol className="gencard__stages">
        {STAGES.map((k, i) => (
          <li
            key={k}
            className={'gencard__stage' + (i < now ? ' gencard__stage--done' : '') + (i === now ? ' gencard__stage--now' : '')}
            {...(i === now ? { 'aria-current': 'step' } : {})}
          >
            <span className="gencard__dot" aria-hidden="true" />
            {t(k)}
          </li>
        ))}
      </ol>
      <p className="footnote">{t('gen_keep_chatting')}</p>
    </div>
  );
}
